<script setup>
  import {MedButton} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "ComponentSearchWrapper",
  });

  defineProps({
    disabled: {
      type: Boolean,
      default: false,
    },
    setFocus: {
      type: Function,
      default: () => ({}),
    },
  });
</script>

<template>
  <div class="bg-linear-to-b from-gray-100 via-gray-50 to-gray-100 p-4" :data-test="getTestId('wrapper')">
    <div class="flex items-end text-left">
      <MedButton
        aria-label="Sucheingabe aktivieren"
        variant="primary"
        flat
        icon="search"
        size="sm"
        rounded="full"
        :disabled="disabled"
        :data-test="getTestId('wrapper-button')"
        @click="setFocus"
      />

      <slot />
    </div>
  </div>
</template>
